import { Heading } from "@chakra-ui/react";

import { sanitizeID } from "../../../../../utils/helpers";
import { IHeading } from "../../../../../utils/types";

interface HeadingContentProps {
  field: IHeading;
}

export default function HeadingContent({ field }: HeadingContentProps) {
  const headingContainerId = sanitizeID(field.id || field.content);

  const headingId = `heading-${headingContainerId}-${
    field.styles?.fontSize || "md"
  }`;

  return (
    <div id={headingContainerId}>
      <Heading
        {...field.styles}
        color="gray.800"
        data-testid={headingId}
        id={headingId}
      >
        {field.content}
      </Heading>
    </div>
  );
}
